import { helpers } from "@vuelidate/validators";

/**
 * If OKPO is 10 digits (IPN) → IBAN[15–20] must NOT start with "2620".
 * Otherwise → no IBAN check.
 *
 * getOkpo: () => string | number
 */
export const ibanBalanceByOkpo = (getOkpo) =>
	helpers.withParams({ type: "ibanBalanceByOkpo" }, (value) => {
		if (!helpers.req(value)) return true;

		const okpo = String((getOkpo && getOkpo()) ?? "").trim();
		const isIpn10 = /^\d{10}$/.test(okpo);

		if (!isIpn10) return true;

		const s = String(value).replace(/\s+/g, "").toUpperCase();
		const code15to20 = s.slice(15, 20);

		return !code15to20.startsWith("2620");
	});
